import { LineChart } from 'lucide-react';

const ChartsIcon = () => {
  return (
    <LineChart />
  );
};

export default ChartsIcon;